import { logger } from '@/plugins/logger';

export class StorageService {
  storage: Storage;

  constructor(storage: Storage) {
    this.storage = storage;
  }

  getItem(key: string) {
    const data = this.storage.getItem(key);
    try {
      return data ? JSON.parse(data) : null;
    } catch (e) {
      logger.error(e);
      return data;
    }
  }

  setItem(key: string, data: object) {
    try {
      this.storage.setItem(key, JSON.stringify(data));
    } catch (e) {
      logger.error(e);
    }
  }

  removeItem(key: string) {
    this.storage.removeItem(key);
  }
}

export const createLocalStorage = () => (typeof localStorage !== 'undefined' ? new StorageService(localStorage) : null);

export const createSessionStorage = () => (typeof sessionStorage !== 'undefined' ? new StorageService(sessionStorage) : null);
